import styled, { css } from 'styled-components';
import mq from '../../../utils/mediaQueries.js';
import Button from '../../Button/Button.js';

// @ts-nocheck
var FooterContent = styled.div.withConfig({
  displayName: "style__FooterContent",
  componentId: "sc-1icl6qt-0"
})(["display:flex;", " ", ""], mq.sMax(css(["flex-wrap:wrap;gap:8px;padding:24px 16px;background:var(--color-white);"])), mq.s(css(["flex-wrap:wrap;gap:0.8rem;padding:1.6rem 16px 0.8rem;"])));
var ClearFilterButton = styled(Button).withConfig({
  displayName: "style__ClearFilterButton",
  componentId: "sc-1icl6qt-1"
})(["flex:1 1 auto;"]);
var ShowTripButton = styled(Button).withConfig({
  displayName: "style__ShowTripButton",
  componentId: "sc-1icl6qt-2"
})(["", " ", ""], mq.sMax(css(["flex:1 1 auto;"])), mq.s(css(["display:none !important;"])));

export { ClearFilterButton, FooterContent, ShowTripButton };
//# sourceMappingURL=style.js.map
